import React from "react";
import "./Footer.css";
const Footer = () => {
	return (
		<>
			<footer>
				<div class="footer">
					<div class="contain">
						<div class="col">
							<h2>Company</h2>
							<ul>
								<li>About us</li>
								<li> Our Mission</li>
								<li>Services</li>
							</ul>
						</div>
						<div class="col">
							<h2>Products</h2>
							<ul>
								<li>SEO</li>
								<li>Content Development</li>
								<li>Digital Marketing</li>
							</ul>
						</div>
						<div class="col">
							<h2>Team</h2>
							<ul>
								<li>Developer </li>
								<li>Finance </li>
								<li>Content writing</li>
							</ul>
						</div>
						<div class="col">
							<h2>Resources</h2>
							<ul>
								<li>Website Maintenance</li>
								<li>Web templates</li>
								<li>Responsive websites</li>
							</ul>
						</div>
						<div class="col">
							<h2>Contact</h2>
							<ul>
								<li>+91-9354851064</li>
								<li>+91-8130080818</li>
								<li>jatulkumar02@gmail.com</li>
							</ul>
						</div>
						<div class="col address">
							<h2>Address </h2>
							<ul>
								<li>Janakpuri Janak Cinema Near Cinepolis 110046</li>
							</ul>
						</div>
						<div class="clearfix"></div>
					</div>
				</div>
			</footer>
		</>
	);
};

export default Footer;
